const PREFIX = 'DEVICE'

export const SET_DEVICES = PREFIX + '.SET_DEVICES'
export const APPEND_DEVICES = PREFIX + '.APPEND_DEVICES'
